export { default } from './mobile-publications-page-header';
